<template lang="pug">
  .form-col.large-24(v-if="reason_for_transfer.active")
    label.transfer-information-text {{ reason_for_transfer.name }}
    .form-col.large-24
      span.required
      validation-provider(:rules="{ required: reason_for_transfer.required }" v-slot="{ errors }" ref="reason_selector")
        span.required(v-if="reason_for_transfer.required")  *
        span.reason_title(:class="{ error: errors[0] }") {{'Reason'}}
        br
        span.description(
          v-if="reason_for_transfer.description"
          )
          | {{ reason_for_transfer.description }}
        .select.gap-reason-dropdown(:class="{ error: errors[0] }")
          span.selected
            span.value(v-if="isPresent(reason_data.reason.value)") {{ reason_data.reason.value }}
            span.value(v-else) {{ t("app.buttons.select") }}
            span.caret
          select(v-model="reason_data.reason.value" @change="onChangeReason($event)")
            option(value="" disabled selected) {{ t("app.buttons.select") }}
            option(v-for="r in activeReasons" :key="r.uid" :value="r.name") {{ r.name }}

    .form-col.large-24(v-if="selectedReason && selectedReason.uid === 'divorce'")
      .reason_description
        label {{ selectedReason.description }}

      validation-provider(slim v-slot="{ errors }" ref="divorce" :rules="{ required: reason_data.divorce_data.attachments.length === 0 }")
        span.required *
        label(:class="{error: errors[0]}") {{ 'Upload court order' }}
        ReasonUploadFiles(:model_data="reason_data.divorce_data")
        
    .form-col.large-24(v-if="selectedReason && selectedReason.uid === 'us_military_orders'")
      .reason_description
        label {{ selectedReason.description }}
      validation-provider(slim v-slot="{ errors }" ref="us_military_orders" :rules="{ required: reason_data.us_military_orders_data.attachments.length === 0 }")
        span.required *
        label(:class="{error: errors[0]}") {{ 'Upload Military Order(s)' }}
        ReasonUploadFiles(:model_data="reason_data.us_military_orders_data")
    
    .form-col.large-24(v-if="selectedReason && selectedReason.uid === 'anti_bullying_exception'")
      .reason_description
        label {{ selectedReason.description }}
      validation-provider(slim v-slot="{ errors }" ref="anti_bullying_exception" :rules="{ required: reason_data.anti_bullying_exception_data.attachments.length === 0 }")
        span.required *
        label(:class="{error: errors[0]}") {{ 'Upload documentation' }}
        ReasonUploadFiles(:model_data="reason_data.anti_bullying_exception_data")
          
    .form-col.large-24(v-if="selectedReason && selectedReason.uid === 'death_of_custodial_parents'")
      .reason_description
        label {{ selectedReason.description }}
      validation-provider(slim v-slot="{ errors }" ref="death_of_custodial_parents" :rules="{ required: reason_data.death_of_custodial_parents_data.attachments.length === 0 }")
        span.required *
        label(:class="{error: errors[0]}") {{ 'Upload death certificate(s)' }}
        ReasonUploadFiles(:model_data="reason_data.death_of_custodial_parents_data")
    .form-col.large-24(v-if="selectedReason && selectedReason.uid === 'board_of_education_restructure'")
      .reason_description
        label {{ selectedReason.description }}
      validation-provider(slim v-slot="{ errors }" ref="board_of_education_restructure" :rules="{ required: reason_data.board_of_education_restructure_data.attachments.length === 0 }")
        span.required *
        label(:class="{error: errors[0]}") {{ 'Upload documentation' }}
        ReasonUploadFiles(:model_data="reason_data.board_of_education_restructure_data")

    .form-col.large-24(v-if="selectedReason && selectedReason.uid === 'boarding_school'")
      .reason_description
        label {{ selectedReason.description }}
      validation-provider(slim v-slot="{ errors }" ref="boarding_school" :rules="{ required: reason_data.boarding_school_data.attachments.length === 0 }")
        span.required *
        label(:class="{error: errors[0]}") {{ 'Upload documentation' }}
        ReasonUploadFiles(:model_data="reason_data.boarding_school_data")     

    .form-col.large-24(v-if="selectedReason && selectedReason.uid === 'cessation_of_school_program'")
      .reason_description
        label {{ selectedReason.description }}
      validation-provider(slim v-slot="{ errors }" ref="cessation_of_school_program" :rules="{ required: reason_data.cessation_of_school_program_data.attachments.length === 0 }")
        span.required *
        label(:class="{error: errors[0]}") {{ 'Upload documentation' }}
        ReasonUploadFiles(:model_data="reason_data.cessation_of_school_program_data")

    .form-col.large-24(v-if="selectedReason && selectedReason.uid === 'change_of_sole_custody'")
      .reason_description
        label {{ selectedReason.description }}
      span.required(v-if="selectedReason.nested_fields[0].required") *
      validation-provider(:rules="{ required: selectedReason.nested_fields[0].required }" v-slot="{ errors }" ref="is_first_time_sole_custody")
        label(:class="{ error: errors[0] }") {{ selectedReason.nested_fields[0].name }}
        span.description(v-if="selectedReason.nested_fields[0].description") {{ selectedReason.nested_fields[0].description }}
        .checkbox-field2
          label(for="yes_is_first_time_sole_custody" :class="{ error: errors[0] }")
            input(
              type="radio"
              name="is_first_time_sole_custody"
              class="no-custom"
              :value="true"
              v-model="reason_data.change_of_sole_custody_data.question1.value"
              id="yes_is_first_time_sole_custody"
            )
            span.label-text {{ t('app.general._yes') }}
        .checkbox-field2
          label(for="no_is_first_time_sole_custody" :class="{ error: errors[0] }")
            input(
              type="radio"
              name="is_first_time_sole_custody"
              class="no-custom"
              :value="false"
              v-model="reason_data.change_of_sole_custody_data.question1.value"
              id="no_is_first_time_sole_custody"
            )
            span.label-text {{ t('app.general._no') }}

    .form-col.large-24(v-if="selectedReason && selectedReason.uid === 'change_of_sole_custody'") 
      validation-provider(slim v-slot="{ errors }" ref="change_of_sole_custody" :rules="{ required: reason_data.change_of_sole_custody_data.attachments.length === 0 }")
        .reason_description
          span.required *
          label(:class="{error: errors[0]}") {{ 'Upload custody order' }}
          ReasonUploadFiles(:model_data="reason_data.change_of_sole_custody_data")  
      
    .form-col.large-24(v-if="selectedReason && selectedReason.uid === 'change_of_joint_custody'")
      .reason_description
        label {{ selectedReason.description }}
      span.required(v-if="selectedReason.nested_fields[0].required") *
      validation-provider(:rules="{ required: selectedReason.nested_fields[0].required }" v-slot="{ errors }" ref="is_first_time_joint_custody" )
        label(:class="{ error: errors[0] }") {{ selectedReason.nested_fields[0].name }}
        span.description(v-if="selectedReason.nested_fields[0].description") {{ selectedReason.nested_fields[0].description }}
        .checkbox-field2
          label(for="yes_is_first_time_joint_custody" :class="{ error: errors[0] }")
            input(
              type="radio"
              name="is_first_time_joint_custody"
              class="no-custom"
              :value="true"
              v-model="reason_data.change_of_joint_custody_data.question1.value"
              id="yes_is_first_time_joint_custody"
            )
            span.label-text {{ t('app.general._yes') }}
        .checkbox-field2
          label(for="no_is_first_time_joint_custody" :class="{ error: errors[0] }")
            input(
              type="radio"
              name="is_first_time_joint_custody"
              class="no-custom"
              :value="false"
              v-model="reason_data.change_of_joint_custody_data.question1.value"
              id="no_is_first_time_joint_custody"
            )
            span.label-text {{ t('app.general._no') }}

    .form-col.large-24(v-if="selectedReason && selectedReason.uid === 'change_of_joint_custody'") 
      validation-provider(slim v-slot="{ errors }" ref="change_of_joint_custody" :rules="{ required: reason_data.change_of_joint_custody_data.attachments.length === 0 }")
        .reason_description
          span.required *
          label(:class="{error: errors[0]}") {{ 'Upload custody order' }}
          ReasonUploadFiles(:model_data="reason_data.change_of_joint_custody_data")
    .form-col.large-24(v-if="selectedReason && selectedReason.uid === 'does_not_meet_waiver_criteria'")
      .reason_description
        label {{ selectedReason.description }} 
      validation-provider(slim v-slot="{ errors }" ref="does_not_meet_waiver_criteria" :rules="{ required: true }")
        span.required *
        label(:class="{error: errors[0]}") {{ 'Explanation of waiver request' }}
        .field
          textarea(placeholder="Enter Explanation" v-model="reason_data.does_not_meet_waiver_criteria_data.explanantion_of_waiver_request" :class="{error: errors[0]}")
        ReasonUploadFiles(:model_data="reason_data.does_not_meet_waiver_criteria_data")
    .form-col.large-24(v-if="selectedReason && selectedReason.uid === 'change_of_address'")
      .reason_description
        label {{ selectedReason.description }}
      .current-address
        .address-fields.height-adjuster
          .form-col.large-12
            validation-provider(rules="required" v-slot="{ errors }" ref="new_address")
              span.required *
              label(:class="{ error: errors[0] }") {{ 'New/current address' }}
              input(type="text" placeholder="Enter Line 1" v-model="reason_data.change_of_address_data.new_current_address.address_1" :class="{ error: errors[0] }")
          .form-col.large-12
            label {{ 'Address 2' }}
            input(type="text" placeholder="Enter Line 2" v-model="reason_data.change_of_address_data.new_current_address.address_2")
        .address-field-city
          .form-col.large-8.height-adjuster
            validation-provider(rules="required" v-slot="{ errors }" ref="new_city")
              span.required *
              label(:class="{ error: errors[0] }") {{ 'City' }}
              input(type="text" placeholder="Enter City" v-model="reason_data.change_of_address_data.new_current_address.city" :class="{ error: errors[0] }")
          .form-col.large-8.height-adjuster
            validation-provider(rules="required" v-slot="{ errors }" ref="current_state")
              span.required *
              label(:class="{ error: errors[0] }") State
              select.transfer_city_dropdown(v-model="reason_data.change_of_address_data.new_current_address.state" :class="{ error: errors[0] }")
                option(value="" disabled selected) {{ t("app.buttons.select") }}
                option(v-for="state in states" :key="state" :value="state") {{ state }}
          .form-col.large-8.height-adjuster
            validation-provider(rules="required" v-slot="{ errors }" ref="zip_code")
              span.required *
              label(:class="{ error: errors[0] }") {{ 'Zip/postal code' }}
              input.width-adjuster(type="text" placeholder="Enter zip/postal code" v-model="reason_data.change_of_address_data.new_current_address.zip_postal_code" :class="{ error: errors[0] }")
      
      .form-col.large-24(v-for="nested in selectedReason.nested_fields" :key="nested.uid")
        template(v-if="nested.uid === 'owner_of_current_address' && nested.active")
          validation-provider(:rules="{ required: nested.required }" v-slot="{ errors }" :ref="nested.uid")
            .height-adjuster
              span.required(v-if="nested.required") *
              label(:class="{ error: errors[0] }") {{ nested.name }}
              span.description(v-if="selectedReason.nested_fields[1].description") {{ selectedReason.nested_fields[1].description }}
              input(
                type="text"
                placeholder="Enter status (parents own the home, etc.)"
                v-model="reason_data.change_of_address_data.new_current_address.status.value"
                :class="{ error: errors[0] }"
              )
            // Input + Upload for 'status_of_current_residence'
        template(v-else-if="nested.uid === 'status_of_current_residence' && nested.active")
          validation-provider(:rules="{ required: nested.required }" v-slot="{ errors }" :ref="nested.uid")
            .field.height-adjuster
              span.required(v-if="nested.required") *
              label(:class="{ error: errors[0] }") {{ nested.name }}
              span.description(v-if="selectedReason.nested_fields[1].description") {{ selectedReason.nested_fields[0].description }}
              input(
                type="text"
                placeholder="Enter residence status (owned, rental, etc.)"
                v-model="reason_data.change_of_address_data.new_current_address.residence_status.value"
                :class="{ error: errors[0] }"
              )
          ReasonUploadFiles(:model_data="reason_data.change_of_address_data.new_current_address")
        template(v-else-if="nested.uid === 'previous_home_address' && nested.active")
          .previous-address
            .previous-address-fields.height-adjuster
              .form-col.large-12
                validation-provider(:rules="{ required: nested.required }" v-slot="{ errors }" ref="previous_address")
                  span.required(v-if="nested.required") *
                  label(:class="{ error: errors[0] }") {{ nested.name }}
                  span.description(v-if="selectedReason.nested_fields[2].description") {{ selectedReason.nested_fields[2].description }}
                  input(type="text" placeholder="Enter Line 1" v-model="reason_data.change_of_address_data.previous_address.address_1" :class="{ error: errors[0] }")
              .form-col.large-12
                label {{ 'Address 2' }}
                div.with-height(
                  v-if="selectedReason.nested_fields[2]?.description")
                input(type="text" placeholder="Enter Line 2" v-model="reason_data.change_of_address_data.previous_address_2")
            .previous-address-field-city
              .form-col.large-8.height-adjuster
                validation-provider(:rules="{ required: nested.required }" v-slot="{ errors }" ref="previous_city")
                  span.required(v-if="nested.required") *
                  label(:class="{ error: errors[0] }") {{ 'City' }}
                  input(type="text" placeholder="Enter City" v-model="reason_data.change_of_address_data.previous_address.city" :class="{ error: errors[0] }")
              .form-col.large-8.height-adjuster
                validation-provider(:rules="{ required: nested.required }" v-slot="{ errors }" ref="previous_state")
                  span.required(v-if="nested.required") *
                  label(:class="{ error: errors[0] }") State
                  select.transfer_city_dropdown(v-model="reason_data.change_of_address_data.previous_address.state" :class="{ error: errors[0] }")
                    option(value="" disabled selected) {{ t("app.buttons.select") }}
                    option(v-for="state in states" :key="state" :value="state") {{ state }}
              .form-col.large-8.height-adjuster
                validation-provider(:rules="{ required: nested.required }" v-slot="{ errors }" ref="previous_zip_code")
                  span.required(v-if="nested.required") *
                  label(:class="{ error: errors[0] }") {{ 'Zip/postal code' }}
                  input.width-adjuster(type="text" placeholder="Enter zip/postal code" v-model="reason_data.change_of_address_data.previous_address.zip_postal_code" :class="{ error: errors[0] }")  
        // Input field for 'status_of_previous_address'
        template(v-else-if="nested.uid === 'status_of_previous_address' && nested.active")
          validation-provider(:rules="{ required: nested.required }" v-slot="{ errors }" :ref="nested.uid")
            .height-adjuster
              span.required(v-if="nested.required") *
              label(:class="{ error: errors[0] }") {{ nested.name }}
              span.description(v-if="selectedReason.nested_fields[3].description") {{ selectedReason.nested_fields[3].description }}
            input(
              type="text"
              placeholder="Enter previous residence status (owned, rental, etc.)"
              v-model="reason_data.change_of_address_data.previous_address.residence_status.value"
              :class="{ error: errors[0] }"
            )
        template(v-else-if="mappedQuestions[nested.uid]")
          validation-provider(:rules="{ required: nested.required }" v-slot="{ errors }" :ref="nested.uid")
            .height-adjuster(v-if="nested.active")
              span.required(v-if="nested.required") *
              label(:class="{ error: errors[0] }") {{ nested.name }}
              span.description(v-if="nested.description") {{ nested.description }}
              .checkbox-field2
                label(:for="`yes_${nested.uid}`" :class="{ error: errors[0] }")
                  input(
                    type="radio"
                    class="no-custom"
                    :id="`yes_${nested.uid}`"
                    :name="nested.uid"
                    :value="true"
                    v-model="mappedQuestions[nested.uid].value"
                  )
                  span.label-text {{ t('app.general._yes') }}
              .checkbox-field2
                label(:for="`no_${nested.uid}`" :class="{ error: errors[0] }")
                  input(
                    type="radio"
                    class="no-custom"
                    :id="`no_${nested.uid}`"
                    :name="nested.uid"
                    :value="false"
                    v-model="mappedQuestions[nested.uid].value"
                  )
                  span.label-text {{ t('app.general._no') }}

</template>
<script>
import Vue from 'vue'
import { Upload } from 'ant-design-vue';
Vue.use(Upload)
import 'ant-design-vue/lib/select/style/index.css'
import 'ant-design-vue/lib/upload/style/index.css'
import ReasonUploadFiles from './_upload_file.vue'
export default {
  components: { ReasonUploadFiles },
  props: {
    registration: {
      type: Object,
      default(){
        return {}
      },
    },
    registration_transfers_data: {
      type: String,
      default: '',
    },
    question_type: {
      type: String,
      default: 'transfer',
    },
    reason_data: {
      type: Object,
      default(){
        return {}
      },
    },
    is_participant_seeking: {
      type: String,
      default: '',
    },
    transfer_info: {
      type: Object,
      default(){
        return {}
      },
    },
  },
  data(){
    return {
      reason: '',
      selectedReason: null,
      previousState: '', 
      currentState: '',
      states: [
        "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DC", "DE", "FL", "GA", "HI", "ID", "IL", "IN", "IA",
        "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM",
        "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA",
        "WV", "WI", "WY"
      ].sort(),

      nestedFieldValues: {},
    }
  },

  computed: {
    activeReasons() {
      return this.registration.program.transfer_reasons.filter(reason => reason.active);
    },
    mappedQuestions() {
      const questions = this.reason_data.change_of_address_data?.questions || {};
      const result = Object.keys(questions).reduce((acc, key) => {
        if (questions[key]?.uid) {
          acc[questions[key].uid] = questions[key];
        }
        return acc;
      }, {});
      return result;
    },
    validQuestionUids() {
      return Object.keys(this.mappedQuestions);
    },
    reason_for_transfer() {
      return this.transfer_info?.find(
        x => x.uid === "reason_for_transfer"
      ) ?? {};
    },
  },
  created() {
    this.set_default_reason();
  },
  mounted() {
    if (this.reason_data.reason.value) {
      this.setReasonUid(this.reason_data.reason.value);
    }
  },
  methods: {
    onChangeReason(event) {
      const selectedName = event.target.value;
      this.callReasonDataAndUid(selectedName)
    },
    setReasonUid(selectedName) {
      this.selectedReason = this.activeReasons.find(r => r.name === selectedName) || null;
      this.reason_data.reason.uid = selectedName.toLowerCase().replace(/[()]/g, '').replace(/\s+/g, '_');
    },
    set_default_reason() {
      if (!this.reason_data.reason.value && this.registration.registration_transfers.is_participant_seeking_to_participate) {
        this.callReasonDataAndUid("Not a transfer")
      }
    },
    callReasonDataAndUid(selectedName){
      this.reason_data.reason.value = selectedName;
      this.setReasonUid(selectedName);
    }
  },
}
</script>